import { TemplateEditor } from './scoring-input';
import { useRanking } from './ranking';
import { VocabularyEditor } from './territories';

/**
 * A ranking's List setup tab (the process order of 19 Oct): what belongs to the **list**, not to
 * the edition open — the scoring input's template (filter and columns, RP §9.2) and, on a
 * territorial list, its territory vocabulary (the territories design §3). Both are shared by every
 * year of the list, which the tab says first: under an edition's own tabs they read as that year's.
 */
export function RankingSetupTab() {
  const { key, permitted, listLabel, territorial } = useRanking();
  return (
    <div className="grid max-w-6xl gap-6">
      <p className="text-sm text-muted-foreground" data-list-setup>
        These settings belong to the list, <strong>{listLabel ?? key.list}</strong>, and apply to
        every year of it, not only {key.year}.
      </p>
      <TemplateEditor surveyCode={key.surveyCode} list={key.list} permitted={permitted} />
      {territorial && (
        <VocabularyEditor surveyCode={key.surveyCode} list={key.list} permitted={permitted} />
      )}
    </div>
  );
}
